import dayjs from 'dayjs'

import { Button } from '@/components/button/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/card/card'

import { cn } from '@/lib/utils'

export interface GuideToUnsubscribeCardProps {
  subscriptionExpiryDate: string
  onClickButton: VoidFunction
}

export const GuideToUnsubscribeCard = ({ subscriptionExpiryDate, onClickButton }: GuideToUnsubscribeCardProps) => {
  const formattedExpiryDate = dayjs.utc(subscriptionExpiryDate).format('MMMM D, YYYY')

  return (
    <Card className={cn('max-w-[500px]')}>
      <CardHeader>
        <CardTitle>Account Deletion is a Permanent Action</CardTitle>
      </CardHeader>
      <CardContent>
        <p className={cn('text-sm text-muted-foreground')}>
          Cancel your monthly subscription first to delete your account. Your subscription for this month is active
          until {formattedExpiryDate}.
        </p>
      </CardContent>
      <CardFooter>
        <Button type="button" variant="default" className={cn('w-full')} onClick={onClickButton}>
          Back to Settings page
        </Button>
      </CardFooter>
    </Card>
  )
}
